import $ from 'jquery'

export default {
    state: {
        id: "",
        username: "",
        name:'',
        rating:'',
        photo: "",
        token: "",
        about:"",
        rank:"",
        is_login: false,
        pulling_info: true, // 是否正在从云端拉去信息
    },
    getters: {
    },
    mutations: {
        updateUser(state, user) { //更新登录用户信息
            console.log("更新后的user = ", user)
            state.id = user.id;
            state.username = user.username;
            state.photo = user.photo;
            state.is_login = user.is_login;
            state.name = user.name;
            state.rating = user.rating;
            state.about = user.about;
            state.rank = user.rank;
        },
        updateToken(state, token) { //更新Token
            state.token = token;
        },
        logout(state) { //用户退出 需要清空所有信息
            state.id = "";
            state.username = "";
            state.photo = "";
            state.token = "";
            state.name = "";
            state.rating = "";
            state.about = "";
            state.rank = "",
            state.is_login = false;
        },
        updatePullingInfo(state, pulling_info) {
            state.pulling_info = pulling_info
        },
    },
    actions: {
        login(context, data) { //用户登录了 需要调用后端接口
            $.ajax({
                url: "https://app6132.acapp.acwing.com.cn/api/user/account/token/",
                type: "post",
                data: { //传回账号密码
                    username: data.username,
                    password: data.password,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        localStorage.setItem("jwt_token", resp.token) // 把用户token放到浏览器里面去 保证账号就算刷新了也在
                        context.commit("updateToken", resp.token); //如果成功的画 立刻更新Token
                        data.success(resp);
                    } else {
                        console.log("登录失败了")
                        console.log(resp)
                        data.error(resp);
                    }
                },
                error(resp) {
                    console.log("登录失败了")
                    console.log(resp)
                    // data.error(resp);
                }
            });
        },
        getinfo(context, data) {
            $.ajax({
                url: "https://app6132.acapp.acwing.com.cn/api/user/account/info/",
                type: "get",
                headers: {
                    Authorization: "Bearer " + context.state.token,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        context.commit("updateUser", {
                            ...resp,
                            is_login: true,
                        });
                        data.success(resp);
                        // console.log("我直接登录成功辣: ", resp)
                    } else {
                        console.log("拉去信息失败了")
                    }
                },
                error(resp) {
                    // data.error(resp);
                    console.log("拉去信息失败了， resp: ", resp.error_message)
                }
            })
        },
        logout(context) {
            localStorage.removeItem("jwt_token") // 把用户token放到浏览器里面去 保证账号就算刷新了也在
            context.commit("logout");
        }
    },
}